import React, { useState } from "react";
// import { Link } from "react-router-dom";
import { NavLink } from "react-router-dom";
import "./../Styles/AddDesign.css";
import "./../Styles/AddDesigner.css";
import "./../Styles/Addmachine.css";
import "./../Styles/Beads.css";
import "./../Styles/ChangePassword.css";
import "./../Styles/Dashboard.css";
import "./../Styles/logout.css";
import "./../Styles/profile.css";
import "./../Styles/Settings.css";
import "./../Styles/sidebar.css";
import "./../Styles/userheader.css";
import "./../Styles/ViewDesign.css";
import "./../Styles/Viewdesigner.css";
import "./../Styles/viewmachine.css";
import { useEffect } from "react";
import { API } from "../../config/api";
const closeSidebarMobile = () => {
  if (window.innerWidth <= 768) {
    document.body.classList.remove("sidebar-open");
  }
};

export default function Sidebar() {
  const [supplierTypes, setSupplierTypes] = useState([]);

  const [designOpen, setDesignOpen] = useState(false);
  const [supplierOpen, setsupplierOpen] = useState(false);

  useEffect(() => {
    fetch(`${API.BASE_URL}/api.php?action=supplier_types`)
      .then((res) => res.json())
      .then((data) => {
        if (data.status) {
          setSupplierTypes(data.data);
        }
      })
      .catch((err) => console.log(err));
  }, []);
  const fetchSupplierTypes = async () => {
    try {
      const res = await fetch(`${API.BASE_URL}/api.php?action=supplier_types`);

      const data = await res.json();

      if (data.status) {
        setSupplierTypes(data.data);
      }
    } catch (err) {
      console.log(err);
    }
  };
  useEffect(() => {
    fetchSupplierTypes();
  }, []);
  useEffect(() => {
    const handleRefresh = () => {
      fetchSupplierTypes();
    };

    window.addEventListener("refreshSupplierTypes", handleRefresh);

    return () => {
      window.removeEventListener("refreshSupplierTypes", handleRefresh);
    };
  }, []);
  return (
    <div className="us-container">
      <div className="us-sidebar">
        <div
          style={{
            display: "flex",
            alignItems: "center",
            textAlign: "center",
            justifyContent: "center",
          }}
        >
          <h2 className="us-logo">Admin Panel</h2>
        </div>

        <ul className="us-menu">
          <li>
            <NavLink
              to="/admin/dashboard"
              className="us-link"
              onClick={closeSidebarMobile}
            >
              <i className="bi bi-speedometer2"></i>
              <span>Dashboard</span>
            </NavLink>
          </li>

          <li>
            <NavLink
              to="/admin/add-design"
              className="us-link"
              onClick={closeSidebarMobile}
            >
              <i className="bi bi-grid"></i>
              <span>Upload Free Design</span>
            </NavLink>
          </li>

          <li>
            <div
              className="us-menu-title"
              onClick={() => setDesignOpen(!designOpen)}
            >
              <div className="us-menu-left">
                <i className="bi bi-palette"></i>
                <span> Manage Paid Designs</span>
              </div>

              <i
                className={`bi ${designOpen ? "bi-chevron-up" : "bi-chevron-down"}`}
              ></i>
            </div>

            {designOpen && (
              <ul className="us-submenu">
                <li>
                  <NavLink to="/admin/orders" onClick={closeSidebarMobile}>
                    Paid Design Orders
                  </NavLink>
                </li>

                <li>
                  <NavLink
                    to="/admin/Designer-Reports"
                    onClick={closeSidebarMobile}
                  >
                    Paid Design Report
                  </NavLink>
                </li>

                {/* <li>
                  <Link
                    to="/admin/transaction-details"
                    onClick={closeSidebarMobile}
                  >
                    Transection Detail
                  </Link>
                </li> */}
                <li>
                  <NavLink
                    to="/admin/sub-category"
                    onClick={closeSidebarMobile}
                  >
                    Add SubCategory
                  </NavLink>
                </li>
                <li>
                  <NavLink to="/admin/add-payment" onClick={closeSidebarMobile}>
                    Add Payment
                  </NavLink>
                </li>

                <li>
                  <NavLink to="/admin/rules" onClick={closeSidebarMobile}>
                    Rules
                  </NavLink>
                </li>
              </ul>
            )}
          </li>
          <li>
            <NavLink
              to="/admin/view-designer"
              className="us-link"
              onClick={closeSidebarMobile}
            >
              <i className="bi bi-person-badge"></i>
              <span> View Designers</span>
            </NavLink>
          </li>
          <li>
            <NavLink
              to="/admin/view-sketcher"
              className="us-link"
              onClick={closeSidebarMobile}
            >
              <i className="bi bi-vector-pen"></i>
              <span>View Sketchers</span>
            </NavLink>
          </li>

          <li>
            <NavLink
              to="/admin/view-work"
              className="us-link"
              onClick={closeSidebarMobile}
            >
              <i className="bi bi-person-badge"></i>
              <span> Bids Work Report</span>
            </NavLink>
          </li>
          <li>
            <NavLink
              to="/admin/view-machine"
              className="us-link"
              onClick={closeSidebarMobile}
            >
              <i className="bi bi-gear"></i>
              <span> View Machines</span>
            </NavLink>
          </li>

          {/* <li>
            <div
              className="us-menu-title"
              onClick={() => setMachineOpen(!machineOpen)}
            >
              <div className="us-menu-left">
                <i className="bi bi-gear"></i>
                <span>Manage Machines</span>
              </div>

              <i
                className={`bi ${machineOpen ? "bi-chevron-up" : "bi-chevron-down"}`}
              ></i>
            </div>

            {machineOpen && (
              <ul className="us-submenu">
                <li>
                  <Link to="/admin/add-machine" onClick={closeSidebarMobile}>
                    Add Machine
                  </Link>
                </li>

                <li>
                  <Link to="/admin/view-machine" onClick={closeSidebarMobile}>
                    View Machines
                  </Link>
                </li>
              </ul>
            )}
          </li> */}

          <li>
            <NavLink
              to="/admin/view-workspace"
              className="us-link"
              onClick={closeSidebarMobile}
            >
              <i className="bi bi-building"></i>
              <span> View spaces</span>
            </NavLink>
          </li>
          <li>
            <NavLink
              to="/admin/view-hiring"
              className="us-link"
              onClick={closeSidebarMobile}
            >
              <i className="bi bi-briefcase-fill"></i>
              <span>View Hiring</span>
            </NavLink>
          </li>
          {/* <li>
            <div
              className="us-menu-title"
              onClick={() => setWorkspaceOpen(!workspaceOpen)}
            >
              <div className="us-menu-left">
                <i className="bi bi-building"></i>
                <span>Manage Rent space</span>
              </div>

              <i
                className={`bi ${workspaceOpen ? "bi-chevron-up" : "bi-chevron-down"}`}
              ></i>
            </div>

            {workspaceOpen && (
              <ul className="us-submenu">
                <li>
                  <Link to="/admin/add-workspace" onClick={closeSidebarMobile}>
                    Add spaces
                  </Link>
                </li>

                <li>
                  <Link to="/admin/view-workspace" onClick={closeSidebarMobile}>
                    View spaces
                  </Link>
                </li>
              </ul>
            )}
          </li> */}

          <li>
            <div
              className="us-menu-title"
              onClick={() => setsupplierOpen(!supplierOpen)}
            >
              <div className="us-menu-left">
                <i className="bi bi-truck"></i>
                <span>Manage Supplier</span>
              </div>

              <i
                className={`bi ${
                  supplierOpen ? "bi-chevron-up" : "bi-chevron-down"
                }`}
              ></i>
            </div>

            {supplierOpen && (
              <ul className="us-submenu">
                <li>
                  <NavLink
                    to="/admin/create-supplier-type"
                    onClick={closeSidebarMobile}
                  >
                    Add Supplier Type
                  </NavLink>
                </li>
                <li>
                  <NavLink to="/admin/beads" onClick={closeSidebarMobile}>
                    Add Supplier
                  </NavLink>
                </li>

                <li>
                  <NavLink
                    to="/admin/manage-supplier"
                    onClick={closeSidebarMobile}
                  >
                    View Suppliers
                  </NavLink>
                </li>
              </ul>
            )}
          </li>
          <li>
            <NavLink
              to="/admin/concept-images"
              className="us-link"
              onClick={closeSidebarMobile}
            >
              <i className="bi bi-images"></i>

              <span>Concept Images</span>
            </NavLink>
          </li>
          <li>
            <NavLink
              to="/admin/users"
              className="us-link"
              onClick={closeSidebarMobile}
            >
              <i className="bi bi-people"></i>
              <span>Users</span>
            </NavLink>
          </li>
          <li>
            <NavLink
              to="/admin/transaction-details"
              className="us-link"
              onClick={closeSidebarMobile}
            >
              <i className="bi bi-building"></i>
              <span>Transaction Details</span>
            </NavLink>
          </li>
          <li>
            <NavLink
              to="/admin/ads-plan"
              className="us-link"
              onClick={closeSidebarMobile}
            >
              <i className="bi bi-bag"></i>
              <span>Ads Manager</span>
            </NavLink>
          </li>

          <li>
            <NavLink
              to="/admin/contactmsg"
              className="us-link"
              onClick={closeSidebarMobile}
            >
              <i className="bi bi-chat-left-text"></i>
              <span>Contact Messages</span>
            </NavLink>
          </li>

          <li>
            <NavLink
              to="/admin/profile"
              className="us-link"
              onClick={closeSidebarMobile}
            >
              <i className="bi bi-person-circle"></i>
              <span>Admin Profile</span>
            </NavLink>
          </li>

          <li>
            <NavLink
              to="/admin/logout"
              className="us-link"
              onClick={closeSidebarMobile}
            >
              <i className="bi bi-box-arrow-right"></i>
              <span>Logout</span>
            </NavLink>
          </li>
        </ul>
      </div>
    </div>
  );
}
